var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"secondary my-btn tw-px-3 tw-py-2",attrs:{"rounded":""},on:{"click":function($event){$event.preventDefault();return _vm.onCancel()}}},[_vm._v(" "+_vm._s(_vm.$t("button.cancel"))+" ")]),(
      _vm.$route.name === 'add-failure-tracking' &&
      _vm.$hasPermission({
        context: 'FAILURE_TRACKING_MANAGEMENT',
        action: 'create',
      })
    )?_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2 tw-m-2",attrs:{"rounded":""},on:{"click":function($event){$event.preventDefault();return _vm.onSave()}}},[_vm._v(" "+_vm._s(_vm.$t("button.addFailure"))+" ")]):_vm._e(),(
      _vm.$route.name === 'edit-failure-tracking' &&
      _vm.$hasPermission({
        context: 'FAILURE_TRACKING_MANAGEMENT',
        action: 'update',
      })
    )?_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2 tw-m-2",attrs:{"rounded":""},on:{"click":function($event){$event.preventDefault();return _vm.onSave()}}},[_vm._v(" "+_vm._s(_vm.$t("button.saveChanges"))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }